import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { relativeTime } from "@/lib/format";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";

export const NotificationsAdmin = () => {
  const [notifs, setNotifs] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/notifications");
    setNotifs(r.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const readAll = async () => {
    await api.put("/notifications/read-all");
    toast.success("All notifications marked as read");
    load();
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="text-muted" style={{ fontSize: 14 }}>{notifs.filter(n => !n.read).length} unread</div>
        <button onClick={readAll} className="btn-outline inline-flex items-center gap-2" data-testid="mark-all-read">
          <CheckCheck size={14} /> Mark all read
        </button>
      </div>
      <div className="s-card" style={{ padding: 0 }}>
        {notifs.length === 0 && <div className="text-muted text-center p-10" style={{ fontSize: 13 }}>No notifications yet.</div>}
        {notifs.map(n => (
          <div key={n.id} className="p-4 flex items-start gap-3" style={{
            borderBottom: "1px solid var(--border-dark)",
            background: n.read ? "transparent" : "rgba(46,202,200,0.04)",
          }} data-testid={`notif-${n.id}`}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "rgba(46,202,200,0.12)",
                          display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Bell size={14} color="#2ECAC8" />
            </div>
            <div className="flex-1">
              <div style={{ fontSize: 14, color: "#fff" }}>{n.message}</div>
              <div className="text-muted" style={{ fontSize: 11, marginTop: 4 }}>{n.kind} · {relativeTime(n.created_at)}</div>
            </div>
            {!n.read && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#2ECAC8" }} />}
          </div>
        ))}
      </div>
    </div>
  );
};
